module.exports = __webpack_public_path__ + "img/野本建吾.e681e897.png";